import React from 'react'

export const Information: React.FC = () => {
  return <></>
}
